//Coverages compontent

export const PlusIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='23'
    viewBox='0 0 23 23'
    fill='none'
  >
    <rect x='9.66016' width='3.68' height='23' fill='#283288' />
    <rect
      x='23'
      y='9.65991'
      width='3.68'
      height='23'
      transform='rotate(90 23 9.65991)'
      fill='#283288'
    />
  </svg>
);

export const Shield = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='59'
    height='76'
    viewBox='0 0 59 76'
    fill='none'
  >
    <path
      d='M30.2551 75.175C53.4682 64.423 59 42.5786 59 42.5786V14.2524C59 14.2524 42.9816 15.3923 30.9169 0.676256C30.1872 -0.225419 28.8128 -0.225419 28.0831 0.676256C16.0184 15.3923 0 14.2524 0 14.2524V42.5956C0 42.5956 5.53178 64.44 28.7449 75.192C29.22 75.4132 29.78 75.4132 30.2721 75.192L30.2551 75.175Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const Airplane = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='102'
    height='81'
    viewBox='0 0 102 81'
    fill='none'
  >
    <path
      d='M5.65707 14.4681H8.53134C9.9321 14.4681 11.2601 14.9751 12.1515 15.8624L17.7909 29.8053H42.295L35.5641 4.79855C35.2003 2.26347 37.1832 0 39.7482 0H43.6412C45.2057 0 46.661 0.869172 47.3887 2.26347L67.1994 29.8053H91.7763C97.4157 29.8053 102 34.3504 102 39.9819C102 45.6134 97.4339 50.1584 91.7763 50.1584H67.1812L47.3341 77.7546C46.6065 79.1489 45.1693 80.0181 43.5866 80.0181H39.6936C37.1286 80.0181 35.1639 77.7546 35.5096 75.2196L42.2586 50.1584H15.0621C8.78603 50.1584 3.54684 45.4142 2.96471 39.1852L1.07278 19.0312C0.436066 16.6953 2.63725 14.4862 5.60249 14.4862L5.65707 14.4681Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const Danger = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='71'
    height='71'
    viewBox='0 0 71 71'
    fill='none'
  >
    <path
      d='M35.5 0L0 71H71L35.5 0ZM40.1677 23.1797L38.4072 49.9071H32.5928L30.8323 23.1797H40.1677ZM35.4677 62.7651C34.5471 62.7651 33.6911 62.5404 32.9158 62.0748C32.1406 61.6254 31.5107 60.9993 31.0423 60.2288C30.5578 59.4583 30.3155 58.5915 30.3155 57.6444C30.3155 56.2157 30.8323 54.9957 31.8499 53.9844C32.8674 52.957 34.0626 52.4434 35.4677 52.4434C36.8728 52.4434 38.1649 52.957 39.1663 53.9844C40.1838 54.9957 40.6845 56.2157 40.6845 57.6444C40.6845 59.073 40.1838 60.2449 39.1663 61.2562C38.1649 62.2675 36.9374 62.7651 35.4677 62.7651Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const BrokenShield = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='57'
    height='75'
    viewBox='0 0 57 75'
    fill='none'
  >
    <path
      d='M57 13.7211V24.5964L41.918 21.6319L32.459 39.3697L7.80328 31.6063L0 39.6482V13.7211C0 13.7211 15.4754 14.8184 27.1311 0.651044C27.8525 -0.217015 29.1639 -0.217015 29.8689 0.651044C41.5246 14.8184 57 13.7211 57 13.7211Z'
      fill='#FFF6EF'
    />
    <path
      d='M43.6723 26.9551L57.0001 29.5756V42.6293C57.0001 42.6293 51.6559 63.6592 29.2461 74.0104C28.7706 74.2233 28.2297 74.2233 27.7706 74.0104C10.0821 65.8539 3.03294 51.0478 0.819824 45.1516L8.75425 36.9787L34.0657 44.955L43.6723 26.9551Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const Suitcase = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='53'
    height='107'
    viewBox='0 0 53 107'
    fill='none'
  >
    <path
      d='M47.0868 26.1504H41.2913V7.67641C41.2913 3.44173 37.8643 0 33.6647 0H19.3353C15.1357 0 11.7087 3.44173 11.7087 7.67641V26.1504H5.91315C2.6542 26.1504 0 28.7992 0 32.0722V91.9482C0 95.2212 2.6542 97.8868 5.91315 97.8868H9.55848C8.93693 98.8148 8.56735 99.9283 8.56735 101.126C8.56735 104.332 11.1544 106.93 14.3461 106.93C17.5379 106.93 20.1249 104.332 20.1249 101.126C20.1249 99.9283 19.7553 98.8148 19.1338 97.8868H33.8662C33.2279 98.8148 32.8751 99.9283 32.8751 101.126C32.8751 104.332 35.4621 106.93 38.6539 106.93C41.8456 106.93 44.4326 104.332 44.4326 101.126C44.4326 99.9283 44.0799 98.8148 43.4415 97.8868H47.0868C50.3458 97.8868 53 95.2212 53 91.9482V32.0722C53 28.7992 50.3458 26.1504 47.0868 26.1504ZM11.4063 86.6675V37.3698C11.4063 36.9142 11.5743 36.5262 11.8431 36.2225C12.1623 35.8851 12.599 35.6826 13.0862 35.6826C14.0269 35.6826 14.7661 36.425 14.7661 37.3698V86.6675C14.7661 87.5954 14.0269 88.3546 13.0862 88.3546C12.1455 88.3546 11.4063 87.5954 11.4063 86.6675ZM14.3461 103.556C13.019 103.556 11.9271 102.476 11.9271 101.126C11.9271 99.7764 13.019 98.6967 14.3461 98.6967C15.6732 98.6967 16.7651 99.7933 16.7651 101.126C16.7651 102.459 15.6732 103.556 14.3461 103.556ZM28.1883 86.6675C28.1883 87.5954 27.4323 88.3546 26.5084 88.3546C25.5845 88.3546 24.8285 87.5954 24.8285 86.6675V37.3698C24.8285 36.425 25.5677 35.6826 26.5084 35.6826C27.4491 35.6826 28.1883 36.425 28.1883 37.3698V86.6675ZM15.0685 26.1504V7.67641C15.0685 5.29756 16.9835 3.37424 19.3353 3.37424H33.6647C36.0165 3.37424 37.9315 5.29756 37.9315 7.67641V26.1504H15.0685ZM38.6539 103.556C37.3268 103.556 36.2349 102.476 36.2349 101.126C36.2349 99.7764 37.3268 98.6967 38.6539 98.6967C39.981 98.6967 41.0729 99.7933 41.0729 101.126C41.0729 102.459 39.981 103.556 38.6539 103.556ZM41.5937 86.6675C41.5937 87.5954 40.8377 88.3546 39.9138 88.3546C38.9899 88.3546 38.2339 87.5954 38.2339 86.6675V37.3698C38.2339 36.425 38.9731 35.6826 39.9138 35.6826C40.401 35.6826 40.8377 35.8851 41.1569 36.2225C41.4257 36.5262 41.5937 36.9311 41.5937 37.3698V86.6675Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const Clock = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='69'
    height='69'
    viewBox='0 0 69 69'
    fill='none'
  >
    <path
      d='M34.491 68.9647C53.5368 68.9647 68.9821 53.5194 68.9821 34.4737C68.9821 15.4279 53.5194 0 34.491 0C15.4627 0 0 15.4453 0 34.491C0 53.5368 15.4453 68.9821 34.491 68.9821V68.9647ZM30.4732 14.193H35.3085V34.9781L47.1708 44.2487L44.1618 48.0927L30.4732 37.3262V14.193Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const Pill = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='81'
    height='66'
    viewBox='0 0 81 66'
    fill='none'
  >
    <path
      d='M31.2345 20.1675L49.1284 46.0382L25.6348 62.3853C18.5095 67.3362 8.72795 65.5538 3.79231 58.4245C1.33346 54.8599 0.525813 50.6111 1.26167 46.6504C1.96163 42.6896 4.18716 38.9809 7.75877 36.5145L31.2524 20.1675H31.2345Z'
      fill='#FFF6EF'
      stroke='#FFF6EF'
      stroke-width='1.45'
      stroke-miterlimit='10'
    />
    <path
      d='M76.5884 7.78113C79.0652 11.3458 79.8549 15.5946 79.137 19.5553C78.4191 23.534 76.2115 27.2247 72.6399 29.6912L49.1283 46.0562L31.2344 20.1854L54.746 3.8024C61.8712 -1.14852 71.6348 0.633813 76.5705 7.78113H76.5884Z'
      stroke='#FFF6EF'
      stroke-width='1.45'
      stroke-miterlimit='10'
    />
  </svg>
);

export const Asterisk = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='70'
    height='70'
    viewBox='0 0 70 70'
    fill='none'
  >
    <path
      d='M59.7432 10.2568C53.4164 3.91239 44.6752 0 35 0C25.3248 0 16.5836 3.91239 10.2568 10.2568C3.91239 16.5836 0 25.3424 0 35C0 54.3328 15.6672 70 35 70H70V35C70 25.3424 66.0876 16.5836 59.7432 10.2568ZM56.7472 37.8197L40.146 36.639L52.782 47.5126L48.2351 51.936L37.5025 39.7231L38.2251 56.1833H31.9159L33.2377 39.8817L21.9058 52.218L17.5 47.6712L29.854 37.5201L13.2351 37.8197V31.352L29.854 32.8147L17.5 21.2009L21.9058 16.6541L32.7971 29.7306L31.9159 12.6888H38.2251L37.5025 29.7306L48.2351 16.9361L52.782 21.3595L40.428 32.6737L56.7472 31.352V37.8197Z'
      fill='#FFF6EF'
    />
  </svg>
);

export const RightArrow = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='30'
    viewBox='0 0 37 30'
    fill='none'
  >
    <path
      d='M36.4142 16.4142C37.1953 15.6332 37.1953 14.3668 36.4142 13.5858L23.6863 0.857866C22.9052 0.0768176 21.6389 0.0768175 20.8579 0.857866C20.0768 1.63891 20.0768 2.90524 20.8579 3.68629L32.1716 15L20.8579 26.3137C20.0768 27.0948 20.0768 28.3611 20.8579 29.1421C21.6389 29.9232 22.9052 29.9232 23.6863 29.1421L36.4142 16.4142ZM0 15L-1.74846e-07 17L35 17L35 15L35 13L1.74846e-07 13L0 15Z'
      fill='#283288'
    />
  </svg>
);

export const LeftArrow = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='30'
    viewBox='0 0 37 30'
    fill='none'
  >
    <path
      d='M0.585785 13.5858C-0.195263 14.3668 -0.195263 15.6332 0.585785 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857863C15.3611 0.0768137 14.0948 0.0768136 13.3137 0.857862L0.585785 13.5858ZM37 15L37 13L2 13L2 15L2 17L37 17L37 15Z'
      fill='#283288'
    />
  </svg>
);

export const FullStar = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='134'
    height='22'
    viewBox='0 0 134 22'
    fill='none'
  >
    <path
      d='M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z'
      fill='#283288'
    />
    <path
      d='M39 0L41.4697 7.60081H49.4616L42.996 12.2984L45.4656 19.8992L39 15.2016L32.5344 19.8992L35.004 12.2984L28.5384 7.60081H36.5303L39 0Z'
      fill='#283288'
    />
    <path
      d='M67 0L69.4697 7.60081H77.4616L70.996 12.2984L73.4656 19.8992L67 15.2016L60.5344 19.8992L63.004 12.2984L56.5384 7.60081H64.5303L67 0Z'
      fill='#283288'
    />
    <path
      d='M95 0L97.4697 7.60081H105.462L98.996 12.2984L101.466 19.8992L95 15.2016L88.5344 19.8992L91.004 12.2984L84.5384 7.60081H92.5303L95 0Z'
      fill='#283288'
    />
    <path
      d='M123 0L125.47 7.60081H133.462L126.996 12.2984L129.466 19.8992L123 15.2016L116.534 19.8992L119.004 12.2984L112.538 7.60081H120.53L123 0Z'
      fill='#CEDDFF'
    />
  </svg>
);

export const EmptyStar = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='134'
    height='22'
    viewBox='0 0 134 22'
    fill='none'
  >
    <path
      d='M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z'
      fill='#283288'
    />
    <path
      d='M39 0L41.4697 7.60081H49.4616L42.996 12.2984L45.4656 19.8992L39 15.2016L32.5344 19.8992L35.004 12.2984L28.5384 7.60081H36.5303L39 0Z'
      fill='#283288'
    />
    <path
      d='M67 0L69.4697 7.60081H77.4616L70.996 12.2984L73.4656 19.8992L67 15.2016L60.5344 19.8992L63.004 12.2984L56.5384 7.60081H64.5303L67 0Z'
      fill='#283288'
    />
    <path
      d='M95 0L97.4697 7.60081H105.462L98.996 12.2984L101.466 19.8992L95 15.2016L88.5344 19.8992L91.004 12.2984L84.5384 7.60081H92.5303L95 0Z'
      fill='#283288'
    />
    <path
      d='M123 0L125.47 7.60081H133.462L126.996 12.2984L129.466 19.8992L123 15.2016L116.534 19.8992L119.004 12.2984L112.538 7.60081H120.53L123 0Z'
      fill='#CEDDFF'
    />
  </svg>
);

const QuotationMarks = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='55'
    height='40'
    viewBox='0 0 55 40'
    fill='none'
  >
    <path
      d='M12.445 40C8.88236 40 5.91798 38.7374 3.55186 36.2069C1.18306 33.6818 0 29.9294 0 24.9552C0 20.8363 0.789603 17.1463 2.36611 13.8854C3.94532 10.6245 6.02847 7.81971 8.61826 5.47651C11.208 3.1306 14.0026 1.306 16.9967 0L22.1574 3.91529C21.2654 4.36329 19.9125 5.22129 18.0908 6.48384C16.269 7.74912 14.6009 9.28862 13.081 11.1024C11.5638 12.9188 10.8038 14.8846 10.8038 17.0052C11.2485 16.5572 11.9572 16.2503 12.9274 16.0874C13.9002 15.9245 14.83 15.8431 15.7193 15.8431C17.8644 15.8431 19.9287 16.7092 21.9121 18.4415C23.8956 20.1738 24.8873 22.9976 24.8873 26.9128C24.8873 30.8281 23.6827 34.1406 21.2762 36.4838C18.8669 38.8298 15.9241 40 12.445 40ZM42.555 40C38.9924 40 36.028 38.7374 33.6619 36.2069C31.2958 33.6791 30.11 29.9294 30.11 24.9525C30.11 20.8336 30.8996 17.1436 32.4761 13.8827C34.0553 10.6218 36.1385 7.817 38.7283 5.4738C41.3181 3.12788 44.11 1.306 47.1067 0L52.2674 3.91529C51.3754 4.36329 50.0198 5.22129 48.2008 6.48384C46.3791 7.74912 44.7109 9.28862 43.1937 11.1024C41.6765 12.9188 40.9165 14.8846 40.9165 17.0052C41.3612 16.5572 42.0699 16.2503 43.0401 16.0874C44.0102 15.9245 44.9427 15.8431 45.832 15.8431C47.9771 15.8431 50.0414 16.7092 52.0248 18.4415C54.0083 20.1738 55 22.9976 55 26.9128C55 30.8281 53.7954 34.1406 51.3889 36.4838C48.9796 38.8298 46.0368 40 42.555 40Z'
      fill='#283288'
    />
  </svg>
);
